import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { map } from 'rxjs/operators';

import { Environment } from 'src/environments/environment.model';

import { ProprietaryFertilizerFormService } from './proprietary-fertilizer-form.service';
import {
  CropAid,
  ProprietaryFertilizerData,
  UpsertProprietaryFertilizerData,
} from '../models/proprietary-fertilizer.model';

@Injectable({
  providedIn: 'root',
})
export class ProprietaryFertilizerApiService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);
  private readonly proprietaryFertilizerForm = inject(ProprietaryFertilizerFormService);

  protected baseUrl = this.env.APIM_BASE_URL + '/arable-service/';

  fetchOriginalCropAids() {
    return this.http
      .get<{ cropAids: CropAid[] }>(`${this.baseUrl}crop-aid/`)
      .pipe(map((result) => result?.cropAids || []));
  }

  fetchProprietaryFertilizers(year: number) {
    return this.http
      .get<{ cropAids: CropAid[] }>(`${this.baseUrl}crop-aid/proprietary/${year}`)
      .pipe(
        map((result) =>
          (result?.cropAids || []).map((proprietaryFertilizer) =>
            this.proprietaryFertilizerForm.getProprietaryFertilizerFormValue(proprietaryFertilizer),
          ),
        ),
      );
  }

  upsertProprietaryFertilizer(
    proprietaryFertilizer: ProprietaryFertilizerData,
    cropYear: number,
    originalCropAid: CropAid,
  ) {
    const upsertData: UpsertProprietaryFertilizerData =
      this.proprietaryFertilizerForm.getProprietaryFertilizerUpsertData(
        proprietaryFertilizer,
        cropYear,
        originalCropAid.unitOfMeasurement,
        originalCropAid.fertilizer.density,
      );

    return this.http.post(`${this.baseUrl}crop-aid/proprietary`, upsertData);
  }
}
